import lazySizes from "lazysizes";

// don't change file, mandatory for lazysizes work correctly
// Must be executed before DOM content loaded
// ___________________    . , ; .
// (___________________|~~~~~X.;' .
//                       ' `" ' `
//             TNT

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = 'lazysize';
window.lazySizesConfig.loadMode = 3;
lazySizes.cfg.lazyClass = 'lazysize';
